import React from "react";
import { useIntl } from "react-intl";
import { I18N } from "./i18nc";

export const useI18N = () => {
  const { formatMessage } = useIntl();
  const i18n = React.useCallback((props, keywords) => formatMessage(props, keywords), [formatMessage]);
  return { i18n, I18N };
};
